// extracted by mini-css-extract-plugin
export default {"container":"poster-editor-nav-more-options-panel-module__container--y6T5j","marginBottom":"poster-editor-nav-more-options-panel-module__marginBottom--EzpFq"};